import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Gtag } from 'angular-gtag';
import { Observable } from 'rxjs';
import { AgentLoadedPatient, AuthenticatedUser, SearchUsersFormValue } from 'src/app/core/models';
import { AgentState } from 'src/app/core/store/agent/agent.state';
import { UserState } from 'src/app/core/store/user/user.state';
import { ApiStoreData } from 'src/app/core/store/utils';

@Component({
  selector: 'app-agent-bar',
  templateUrl: './agent-bar.component.html',
  styleUrls: ['./agent-bar.component.scss'],
})
export class AgentBarComponent {
  @Select(UserState.authenticatedUser) agent$!: Observable<AuthenticatedUser | null>;
  @Select(AgentState.searchUsersState) searchUsersState$!: Observable<ApiStoreData<SearchUsersFormValue | null>>;
  @Select(AgentState.agentLoadedPatient) agentLoadedPatient$!: Observable<AgentLoadedPatient>;

  constructor(private store: Store, private gtag: Gtag, private router: Router) {}
}
